export default __webpack_public_path__ + "static/media/dsc_logo.33466a0f.png";